import React from 'react';

type Props = {
  title?: string;
  description?: string;
};

export const PlaceholderPage = ({ title, description }: Props) => {
  return (
    <div>
      {title ? <h2>{title}</h2> : null}
      {description ? <p>{description}</p> : null}
    </div>
  );
};
